var axios = require('axios');

var ValidateOptions = require('ValidateOptions');
var RenderToPage = require('RenderToPage');
var ParseWordpressResponse = require('ParseWordpressResponse');

var App = function(options, template, callback) {

    if (template && typeof template !== "string") {
        throw new Error("ccWp: templates must be a string")
    }

    if (!ValidateOptions(options)) {
        throw new Error("Whoops! ValidateOptions error!");
    }

    var allPosts = [];
    var sourceCount = options.endpoints.length;
    function processAjaxData(apiData) {
        if (apiData !== '') {
            // This assumes that apiData is a formatted like a list of WordPress posts.
            // TODO: check the format of the string.
            apiData.data.forEach(function(post) {
                allPosts[allPosts.length] = post;
            });
        }
        if (--sourceCount == 0) {
            // Sort all posts together, most recent first.
            // (Comparing date strings "YYYY-MM-DDThh:mm:ss" alphabetically does the right thing.)
            allPosts.sort(function(a, b) {
                return (a.date > b.date)
                    ? -1
                    : 1;
            });
            if (allPosts.length > 0) {
                // if 4 or fewer posts, hide the Show More button
                if (allPosts.length <= 4) {
                    // note - if 'news-list' isn't in the string, button equals the target DIV ID
                    // this is why we compare button to options.target, to be sure we're not
                    // hiding the target div when there are <5 posts.
                    var button = options.target.replace("news-list", "button");
                    if (button !== options.target) {
                        jQuery(button).hide();
                    }
                }

                // Pick apart the "post" objects into objects that are easier to render in mustache and limit result count.
                var wpResponse = ParseWordpressResponse(allPosts, 8);

                RenderToPage(wpResponse, options.target, template);
            } 
            else {
                var section = options.target.replace("list", "section");
                jQuery(section).hide();
            }

            callback();
        }
    }

    options.endpoints.forEach(function(endpoint) {

        var ajaxUrl = endpoint.url + '/wp-json/wp/v2/' + endpoint.type + "?_embed";

        if (endpoint.postCount) {
            ajaxUrl += '&per_page=' + endpoint.postCount;
        }
        if (endpoint.filters && typeof endpoint.filters == 'object') {
            for (var attr in endpoint.filters) {
                // for special taxonomies, we have to call differently than with other WP filter[]s
                switch (attr) {
                    case "physicians-NPI":
                        ajaxUrl += '&' + attr + '=' + endpoint.filters[attr]; // Something like &filter[tag]=bananas
                        break;
                    case "institutes-objectID":
                        ajaxUrl += '&' + attr + '=' + endpoint.filters[attr]; // Something like &filter[tag]=bananas
                        break;
                    default:
                        ajaxUrl += '&' + attr + '=' + endpoint.filters[attr]; // Something like &filter[tag]="bananas"
                }
            }
        }

        axios.get(ajaxUrl).then(function(apiData) {
            processAjaxData(apiData);
        }).catch(function(response) {
            if (response instanceof Error) {
                console.log("ccWp: Error with ajax call", response.message);
            } 
            else {
                console.log('request problem, response is: ' + response.status);
            }
            processAjaxData('');
        });
    });
}

module.exports = App;
